import { Outlet } from 'react-router-dom'
import React from 'react'
import { useAuth } from 'hooks/useAuth'

const ProtectedRoute = () => {
  const { isLoading } = useAuth()

  if (isLoading) return null

  return <Outlet />
}

export default ProtectedRoute
